import { Observable } from 'rxjs';

import { UseCase } from '../../base/use-case';

import { AcademyRepository } from '../../repositories/academy.repository';
import {
  ContentResourceModel,
  DataContentResourceModel,
} from '../../models/academy/content-resource.model';

export class UpdateContentResourceUseCase implements UseCase<
  DataContentResourceModel,
  ContentResourceModel
> {
  constructor(private repository: AcademyRepository) {}

  execute(params: DataContentResourceModel): Observable<ContentResourceModel> {
    return this.repository.updateContentResource(params);
  }
}
